var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.574L3 9.57397V23C3.00036 23.1752 3.04673 23.3472 3.13448 23.4988C3.22223 23.6505 3.34828 23.7764 3.5 23.864L15 30.575V16.574Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.843L28 7.84299L16.5 1.13599C16.347 1.04673 16.1731 0.999695 15.996 0.999695C15.8189 0.999695 15.645 1.04673 15.492 1.13599L4 7.84199L16 14.843Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.574V30.574L28.5 23.863C28.6516 23.7755 28.7775 23.6497 28.8653 23.4983C28.953 23.3469 28.9995 23.175 29 23V9.57501L17 16.574Z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.f786a83550d4b6654f5b1329de95522e.svg";
export { ForwardRef as ReactComponent };